<template>
  <q-page class="flex column">
    <PowerBIReportEmbedded
      :reportId="$router.currentRoute.meta.reportId"
      :datasetId="$router.currentRoute.meta.datasetId"
      :groupId="$router.currentRoute.meta.groupId"
      :filterPaneEnabled="$router.currentRoute.meta.filterPaneEnabled"
      :navContentPaneEnabled="$router.currentRoute.meta.navContentPaneEnabled"
    />
  </q-page>
</template>

<script>
import PowerBIReportEmbedded from "@/components/PowerBIReportEmbedded.vue";
export default {
  name: "PerformanceReportEmbedded",
  components: {
    PowerBIReportEmbedded,
  }
};
</script>
